module.exports = __webpack_public_path__ + "static/media/img24.a3e63af1.JPG";